import { useTranslation } from "next-i18next";
import PAText, { FONT_SIZE } from "./typography/PAText/PAText";
import styles from "./waterMark.module.scss";

interface IProps {
  label?: string;
  fontSize?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
}
function WaterMark(props: IProps) {
  const { t } = useTranslation("product");
  const { label = t("SOLD OUT"), fontSize = 1, className = "" } = props;

  return (
    <div className={styles.watermark}>
      <PAText component="span" className={`${styles.label} ${className}`} fontSize={FONT_SIZE[fontSize]}>
        <strong>{label}</strong>
      </PAText>
    </div>
  );
}

export default WaterMark;
